import { css } from '@emotion/react';
import { ReactElement, useCallback, useState } from 'react';
import { ChatAttachment } from 'sdk';

import { useSDK } from '../../../../app';
import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { IS_WEBVIEW } from '../../../layout/headerIconsContainer';

type Interface = {
	className: string;
	attachmentMeta: ChatAttachment;
	disabledClick?: boolean;
	showcaseId: number;
};

const Component = ({ attachmentMeta, className, disabledClick = false, showcaseId }: Interface): ReactElement => {
	const { configuration, attachmentsStore } = useSDK();
	const [src, setSrc] = useState(configuration.basePath + attachmentMeta.link.uri);
	const onClick = async (): Promise<void> => {
		const a = document.createElement('a');
		a.target = '_blank';
		a.rel = 'noreferrer';

		const filename = encodeURIComponent(attachmentMeta.filename || '');
		const uri = encodeURIComponent(
			(await attachmentsStore.refreshAndGetAttachmentUrl(attachmentMeta.id)) as string
		);
		const basePath = configuration.basePath?.replace(/\/v2$/, '');
		a.href = `${basePath}/visitor/resource/preview?showcaseId=${showcaseId}&filename=${filename}&url=${uri}`;

		a.click();
	};
	const onError = useCallback(async () => {
		const src = await attachmentsStore.refreshAndGetAttachmentUrl(attachmentMeta.id);
		if (src) {
			setSrc(src);
		}
	}, [attachmentMeta.id, attachmentsStore]);

	return (
		<img
			className={className}
			src={src}
			onClick={IS_WEBVIEW || disabledClick ? (): void => void 0 : onClick}
			onError={onError}
		/>
	);
};

export const ImagePreview = styled(Component)(
	({
		theme: {
			allSettings: {
				attachments: {
					imagePreview: { ...others },
				},
			},
		},
	}: {
		theme: Theme;
		isFirst?: boolean;
	}) => ({
		...others,
	}),
	css`
		cursor: pointer;
	`
);
